import { useCallback } from 'react';

import type { ScrollConfig, ScrollDirection } from '../types';

interface UseScrollProps {
  config: Required<ScrollConfig>;
  containerRef: React.RefObject<HTMLDivElement | null>;
}

const validateConfig = (config: Required<ScrollConfig>) => {
  if (config.multiplier <= 0 || config.multiplier > 1) {
    console.warn('ScrollConfig multiplier should be between 0 and 1');
    return false;
  }
  return true;
};

export const useScroll = ({ config, containerRef }: UseScrollProps) => {
  if (!validateConfig(config)) {
    config = { behavior: config.behavior, multiplier: 0.8 };
  }

  return useCallback(
    (direction: ScrollDirection) => {
      const element = containerRef.current;
      if (!element) return;

      try {
        const scrollAmount = Math.floor(element.clientWidth * config.multiplier);
        const currentScroll = element.scrollLeft;
        const maxScroll = element.scrollWidth - element.clientWidth;

        const newPosition =
          direction === 'left'
            ? Math.max(0, currentScroll - scrollAmount)
            : Math.min(maxScroll, currentScroll + scrollAmount);

        element.scrollTo({
          left: newPosition,
          behavior: config.behavior,
        });
      } catch (error) {
        console.error('Error during scroll operation:', error);
      }
    },
    [containerRef, config],
  );
};
